import jQuery from 'jquery';

const hideNavTab = () => jQuery('.js-odds-variant0').hide();

export default hideNavTab;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/helpers/hideNavTab.js